import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-book-4",
  "use": "icon-si-glyph-book-4-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-book-4\" id=\"icon-si-glyph-book-4\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1092</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <path d=\"M15,0 L15,16 L3.016,16 L3.016,14 L4,14 L4,12 L3.016,12 L3.016,4 L4,4 L4,2 L3.016,2 L3.016,0 L15,0 L15,0 Z M2,2 L2,4 L3,4 L3,2 L2,2 L2,2 Z M2,12 L2,14 L3,14 L3,12 L2,12 L2,12 Z M17,10.07 L16,10.07 L16,12.913 L17,12.913 L17,10.07 L17,10.07 Z M17,6.018 L16,6.018 L16,9 L17,9 L17,6.018 L17,6.018 Z M17,2.101 L16,2.101 L16,4.96 L17,4.96 L17,2.101 L17,2.101 Z\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-book-4.svg
// module id = eVJV
// module chunks = 62